export var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType["PageView"] = "page_view";
    AnalyticsEventType["PrematterCreated"] = "prematter_created";
    AnalyticsEventType["Started"] = "started";
    AnalyticsEventType["LanguageChange"] = "language_change";
    AnalyticsEventType["MatterTypes"] = "matter_types";
    AnalyticsEventType["QuestionsViewed"] = "questions_viewed";
    AnalyticsEventType["RemovedQuestion"] = "removed_question";
    AnalyticsEventType["AddedQuestion"] = "added_question";
    AnalyticsEventType["ViewForm"] = "view_form";
    AnalyticsEventType["SubmitForm"] = "submit_form";
    AnalyticsEventType["Variant"] = "variant";
    AnalyticsEventType["ViewExtendedForm"] = "view_extended_form";
    AnalyticsEventType["SubmitExtendedForm"] = "submit_extended_form";
    AnalyticsEventType["ViewReport"] = "view_report";
    AnalyticsEventType["DownloadReport"] = "download_report";
    AnalyticsEventType["SignedUp"] = "signed_up";
    AnalyticsEventType["VerifiedReport"] = "verified_report";
    AnalyticsEventType["CookieConsent"] = "cookie_consent";
    AnalyticsEventType["LawyerIntroduction"] = "lawyer_introduction";
    AnalyticsEventType["LawyerSmsNotification"] = "lawyer_sms_notification";
    AnalyticsEventType["QuoteRequested"] = "quote_requested";
    AnalyticsEventType["LeadCategorizationMethodAssigned"] = "lead_categorization_method_assigned";
    AnalyticsEventType["LeadCategorizationQuestionAnswered"] = "lead_categorization_question_answered";
    AnalyticsEventType["LeadCategorizationCompleted"] = "lead_categorization_completed";
    AnalyticsEventType["LeadClassified"] = "lead_classified";
    AnalyticsEventType["LawyerFlowStarted"] = "lawyer_flow_started";
    AnalyticsEventType["FlowSwitchedToLawyer"] = "flow_switched_to_lawyer";
    AnalyticsEventType["LawyerIntentDetected"] = "lawyer_intent_detected";
    AnalyticsEventType["LawyerSubmissionReady"] = "lawyer_submission_ready";
    AnalyticsEventType["LawyerFlowCompleted"] = "lawyer_flow_completed";
})(AnalyticsEventType || (AnalyticsEventType = {}));
//# sourceMappingURL=analytics.js.map